import { render, staticRenderFns } from "./CharacterCounter.vue?vue&type=template&id=a4bd5632&"
import script from "./CharacterCounter.vue?vue&type=script&lang=js&"
export * from "./CharacterCounter.vue?vue&type=script&lang=js&"
import style0 from "./CharacterCounter.vue?vue&type=style&index=0&id=a4bd5632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports